<div class="field field-select" [class.arrow-fit-select]="arrowFit" [class.d-flex]="arrowFit" [class.h-100]="arrowFit" [class.align-items-center]="arrowFit">
    <span *ngIf="label" class="label" [class.hide-text]="hideLabel">{{label}} <span *ngIf="optionalString">({{optionalString}})</span></span>
    <select [ngModel]="model || undefined" (ngModelChange)="modelChange.emit($event)" [class.h-100]="arrowFit" [class.model-empty]="!model" [class.error-field]="error">
        <option *ngFor="let option of options;" [ngValue]="option.value">{{option.title}}</option>
    </select>
    <div class="arrow-fit" *ngIf="arrowFit">
        {{getSelected()}} <img src="{{arrowFit}}" alt="">
    </div>
    <span *ngIf="error" class="error-field-display">{{error}}</span>
</div>